import React from "react";

import Project from "./project";

import INFO from "../../data/user";

import "./styles/allProjects.css";

const AllProjects = () => {
	return (
		<div className="all-projects-container">
			{INFO.projects.map((project, index) => (
				<div className="all-projects-project" key={index}>
					<Project
						logo={project.logo}
						techStackUsed={project.techStackUsed}
						title={project.title}
						description={project.description}
						livelink={project.livelink}
						linkText={project.linkText}
						linkText2={project.linkText2}
						link={project.link}
					/>
				</div>
			))}
		</div>
	);
};

export default AllProjects;
